import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import { PDFTranscript } from './PDFTranscript';
import { Semester } from '../types/grades';

interface TranscriptButtonProps {
  semesters: Semester[];
}

export function TranscriptButton({ semesters }: TranscriptButtonProps) {
  const [showPDF, setShowPDF] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowPDF(true)}
        className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white 
                 rounded-md hover:bg-blue-700 transition-colors w-full sm:w-auto
                 justify-center sm:justify-start"
      >
        <FileText size={20} />
        View Transcript
      </button>

      {showPDF && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg w-full max-w-6xl h-[90vh] flex flex-col">
            <div className="p-4 border-b flex justify-between items-center">
              <h2 className="text-xl font-semibold">Academic Transcript</h2>
              <button
                onClick={() => setShowPDF(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                Close
              </button>
            </div>
            <div className="flex-1 p-4">
              <PDFTranscript semesters={semesters} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}